// Copyright (c) 2019-present Ithpower, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import {DepartmentNode} from 'types/organization';

// 获取单部门相关人员的user_id
export const pickMemberIdsFromDepartment = (department: DepartmentNode) => {
    let ids: string[] = [];
    if (!department) {
        return ids;
    }
    const {roles_map: rolesMap, member_ids: memberIds} = department;
    if (rolesMap) {
        for (const id of Object.values(rolesMap)) {
            if (id) {
                ids.push(id);
            }
        }
    }
    if (memberIds && memberIds.length) {
        ids = ids.concat(memberIds);
    }
    return ids;
};

// 获取单部门有效成员的user_id
export const pickEffectiveMemberIdsFromDepartment = (department: DepartmentNode) => {
    let ids: string[] = [];
    if (!department) {
        return ids;
    }
    const {roles_map: rolesMap, member_ids: memberIds} = department;
    if (rolesMap?.Manager) {
        ids.push(rolesMap.Manager);
    }
    if (memberIds && memberIds.length) {
        ids = ids.concat(memberIds);
    }
    return ids;
};

export const computePersonCount = (department: DepartmentNode) => {
    if (!department) {
        return 0;
    }
    const {roles_map: rolesMap, member_ids: memberIds} = department;
    let count = 0;
    if (rolesMap?.Manager) {
        count++;
    }
    if (memberIds && memberIds.length) {
        count += memberIds.length;
    }
    return count;
};

// 获取部门节点树有效成员的user_id
export const getUserIdsFromDepartmentTree = (node: DepartmentNode) => {
    const userIds: Set<string> = new Set<string>();
    const traverse = (node: DepartmentNode) => {
        if (node.roles_map?.Manager) {
            userIds.add(node.roles_map.Manager);
        }
        if (node.member_ids.length) {
            node.member_ids.forEach((userId) => {
                userIds.add(userId);
            });
        }
        if (node.children) {
            node.children.forEach((subDepartment) => {
                traverse(subDepartment);
            });
        }
    };

    traverse(node);
    return [...userIds];
};

export const isLeafDepartment = (node: DepartmentNode): boolean => {
    let leaf = node.leaf;
    if (leaf && (node.member_ids.length || node.roles_map?.Manager)) {
        leaf = false;
    }
    return leaf;
};
